import React from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { returnUpDownClassname } from "utils/helpers";
import GenericCard from "components/UI/GenericCard/GenericCard";
dayjs.extend(relativeTime);

const RecentTrades = ({ trades }) => {
  return (
    <GenericCard title="Recent Trades" disableToggle>
      <div className="flex flex-col gap-3.5 py-2">
        {trades && trades.length > 0 ? (
          trades.map((trade, idx) => {
            const isPositive = trade.pnl > 0;
            const isNegative = trade.pnl < 0;
            return (
              <div
                key={idx}
                className="flex items-center justify-between bg-[var(--neutral-800)] rounded-[10px] shadow-[0_2px_8px_rgba(0,0,0,0.18)] min-h-[56px] border border-[var(--neutral-700)] border-l-4 border-l-[var(--primary)] text-[var(--text-primary)] text-sm p-[10px_16px_10px_12px] relative transition-all duration-200 cursor-pointer hover:shadow-[0_4px_16px_rgba(0,0,0,0.28)] hover:bg-[var(--neutral-700)] hover:translate-y-[-2px] hover:scale-[1.01]"
              >
                <div className="font-medium text-sm tracking-wider flex-1">
                  {trade.symbol}
                </div>
                <div className="text-[var(--neutral-400)] min-w-[70px] text-start flex-1 text-sm lg:block hidden">
                  Amount:{" "}
                  <span className="text-[var(--neutral-50)] font-medium">
                    {trade.amount}
                  </span>
                </div>
                <div className="min-w-[70px] text-center flex-1 font-medium text-sm">
                  <span className={returnUpDownClassname(trade.percent)}>
                    {trade.percent > 0 ? "+" : ""}
                    {trade.percent.toFixed(2)}%
                  </span>
                </div>
                <div className="min-w-[100px] text-start flex-1 font-medium text-sm flex items-center justify-start">
                  <span
                    className={`${returnUpDownClassname(
                      trade.pnl
                    )} mr-1 text-sm`}
                  >
                    {isPositive ? "▲" : isNegative ? "▼" : ""}
                  </span>
                  <span className={returnUpDownClassname(trade.pnl)}>
                    {trade.pnl > 0 ? "+" : ""}
                    {trade.pnl.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>
                <div className="text-[var(--text-tertiary)] text-sm min-w-[90px] lg:text-end flex-1 font-normal">
                  {dayjs(trade.closeDate).fromNow()}
                </div>
              </div>
            );
          })
        ) : (
          <div className="w-full text-center py-8 text-[#888]">
            No recent trades
          </div>
        )}
      </div>
    </GenericCard>
  );
};
export default RecentTrades;
